var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2402 21.59V7.65C29.2402 3.42502 25.8152 0 21.5902 0L7.65024 0C3.42526 0 0.000244141 3.42502 0.000244141 7.65V21.59C0.000244141 25.815 3.42526 29.24 7.65024 29.24H21.5902C25.8152 29.24 29.2402 25.815 29.2402 21.59Z",
    fill: "url(#paint0_linear_701_12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23H16.3446C13.9542 23 12.1721 21.7622 12.1721 18.8V14.0589H10V11.4893C12.3904 10.8657 13.3906 8.79948 13.5101 7H15.9919V11.0723H18.8843V14.0589H15.9882V18.1914C15.9882 19.4292 16.6096 19.8556 17.5967 19.8556H19V23Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_701_12",
    x1: 27.0002,
    y1: 2.25,
    x2: 2.25023,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0344BC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.4f9cc061ab07525b93ecf01a902efaba.svg";
export { ForwardRef as ReactComponent };